import { Spinner } from "@fluentui/react-components";
import { Navigate, Outlet } from "react-router-dom";
import { useGetUserAccessLevel } from "../../hooks/useGetUserAccessLevel";

export function AdminRouteGuard() {
  const accessLevel = useGetUserAccessLevel();

  if (accessLevel === -1) return <Spinner />;
  if (accessLevel < 3) return <Navigate to="/" replace />;
  return <Outlet />;
}
